function _SocialMediaFeed() {
    // Shorterns the size of the content.
    const formatPosts = () => {
        // Get the full text of each post
        const postsTexts = document.querySelectorAll('.crt-post-text');

        // for each post's full text
        for (let x = 0; x < postsTexts.length; x++) {
            // If the amount of characters in the post exceeds 500 characters
            if (postsTexts[x].innerHTML.length > 250) {
                // Reduce the amount of characters to that of 250
                const shortenedPostText = postsTexts[x].innerHTML.substring(
                    0,
                    250
                );
                // Add the text "..." to the end of the reduced text
                postsTexts[x].innerHTML = `${shortenedPostText}...`;
            }
        }
    };

    // An interval that waits for the social media feed to load, before shorterning the content.
    const reduceSocialMediaFeedsContent = setInterval(() => {
        // Gets all instances of crt-post-text
        const posts = document.querySelectorAll('.crt-post');

        if (posts.length !== 0) {
            formatPosts();

            clearInterval(reduceSocialMediaFeedsContent);
        }
    }, 3000);

    let timeoutHandle;

    // Because the articles content regenerates when the page is resized, a function will re-remove the regenerated content.
    const onresize = (element, callbackFunc) => {
        const resizeObserver = new ResizeObserver(() => callbackFunc());
        resizeObserver.observe(element);
    };

    const socialMediaFeedsContainers = document.querySelectorAll(
        '.social-media-feed-container'
    );

    onresize(socialMediaFeedsContainers[0], () => {
        window.clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(() => {
            for (let x = 0; x < socialMediaFeedsContainers.length; x++) {
                formatPosts();
            }
        });
    });

    // // Set a timeout that waits 5 seconds before running any other code, allowing the media posts to load.
    // const reduceSocialMediaFeedsContent = setTimeout(() => {
    //     // Get a list of the social posts
    //     const socialPosts = document.querySelectorAll('article');

    //     // For each social post
    //     for (let x = 0; x < socialPosts.length; x++) {
    //         // Get the crt-post-text child element
    //         const socialPostText =
    //             socialPosts[x].querySelector('.crt-post-text');
    //         // Get the innerHTML of the crt-post-text element
    //         const socialPostTextInnerHTML = socialPostText.innerHTML;

    //         if (socialPostTextInnerHTML) {
    //             // Remove any spaces between instances of any <br> <br>s that appear.
    //             const removedSpacesBetweenBreaksString =
    //                 socialPostTextInnerHTML.replace(/<br> <br>/g, (match) =>
    //                     match.replace(/ /g, '')
    //                 );

    //             // Find the index location of the end of the 3rd paragraph.
    //             const locationOfFourthParagraph =
    //                 removedSpacesBetweenBreaksString
    //                     .split('<br><br>', 3)
    //                     .join('<br><br>').length;

    //             // Slice the social post from the start of the content until the end of the 3rd paragraph
    //             const reducedPostText = removedSpacesBetweenBreaksString.slice(
    //                 0,
    //                 locationOfFourthParagraph
    //             );

    //             // Set the crt-post-text innerHTML to be the created string
    //             socialPostText.innerHTML = reducedPostText;
    //         }
    //     }

    //     if (socialPosts.length !== 0) {
    //         clearInterval(reduceSocialMediaFeedsContent);
    //     }
    // }, 5000);
}

_SocialMediaFeed();
